import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { Period } from '../period-selection/period';
import { PeriodSelection } from '../period-selection/period-selection.enum';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { PeriodSelectionComponent } from '../period-selection/period-selection.component';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'pcp-period-selection-dialog',
    templateUrl: './period-selection-dialog.component.html',
    styleUrls: ['./period-selection-dialog.component.scss'],
    imports: [CdkScrollable, MatDialogContent, PeriodSelectionComponent, MatDialogActions, MatButton, MatDialogClose]
})
export class PeriodSelectionDialogComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: Period,
    private dialogRef: MatDialogRef<PeriodSelectionDialogComponent>
  ) {}
  periodSelection = PeriodSelection;
  ngOnInit() {}
  valueChanged() {
    if (this.data.period !== PeriodSelection.Custom) {
      this.dialogRef.close(this.data);
    }
  }
}
